import styled from 'styled-components';
import { colors } from '@a0/quantum-web';

export const Wrapper = styled.section`
  padding: 3.2rem 6.4rem 6.4rem;
  margin: 0 auto;
  max-width: 54.4rem;
  background: black;
  border-radius: 2.4rem;
  box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.075),
    0 1.2rem 1.2rem rgba(0, 0, 0, 0.1);
`;

export const Title = styled.p`
  font-family: 'SpaceGrotesk', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.8rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: ${colors.neutral_n20};
  padding-bottom: 1.6rem;
  margin: 0 0 3.2rem;
  border-bottom: 0.1rem solid ${colors.neutral_n800};
`;

export const LinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2.4rem 3.2rem;
`;

export const Link = styled.a`
  text-decoration: none;

  p {
    color: white;
    margin: 0;
    transition: all 0.2s ease;
  }

  p:nth-child(2) {
    color: ${colors.neutral_n60};
  }

  p:first-of-type:after {
    transition: all 0.2s ease;
    opacity: 0;
    content: '→';
    padding-left: 0.5rem;
    position: absolute;
    right: -2rem;
  }

  :hover {
    p:first-child {
      color: white;
      position: relative;
      display: inline-block;
      :after {
        opacity: 1;
      }
    }
    p:nth-child(2) {
      color: ${colors.neutral_white};
    }
  }
`;
